function ActionsCellWrapper({ children }) {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
            }}>
            {children}
        </div>
    );
}

export default ActionsCellWrapper;
